/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

import { Endpoint } from '../index';
import { z } from '../zod';

export const JiraAttachmentPost = {
  id: 'jira-attachment.post',
  tag: 'Support',
  summary: 'Create Jira attachment',
  description: 'Create Jira attachment',
  method: 'post',
  flags: { isAuthorized: true },
  route: () => `/jira/attachment`,
  request: {
    body: {
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.any(),
        },
      },
    },
  },
} as const satisfies Endpoint;
